export const NAME = 'header';

/**
 * Here goes the actionTypes
 */
export const HEADER_TOGGLE_MENU_MOBILE_SLIDE = 'HEADER_TOGGLE_MENU_MOBILE_SLIDE';

export const RECHERCHE_VERSION_MENU_MOBILE_SLIDE = 'RECHERCHE_VERSION_MENU_MOBILE_SLIDE';
export const MEMBRE_VERSION_MENU_MOBILE_SLIDE = 'MEMBRE_VERSION_MENU_MOBILE_SLIDE';
export const MENU_VERSION_MENU_MOBILE_SLIDE = 'MENU_VERSION_MENU_MOBILE_SLIDE';
export const CATEGORIES_VERSION_MENU_MOBILE_SLIDE = 'CATEGORIES_VERSION_MENU_MOBILE_SLIDE';



// WEBPACK FOOTER //
// ./src/services/header/constants.js